import {
  Box,
  Button,
  Flex,
  Text,
  Tooltip,
  UnstyledButton,
} from "@mantine/core";
import WaveformVisualizer from "./WaveformVisualizer";
import RecordingRedoSvg from "../Svgs/RecordingRedoSvg";
import RecordingCancelSvg from "../Svgs/RecordingCancelSvg";
import RecordingTickMarkSvg from "../Svgs/RecordingTickMarkSvg";

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const paddedMins = mins.toString().padStart(2, "0");
  const paddedSecs = secs.toString().padStart(2, "0");

  return hrs > 0
    ? `${hrs}:${paddedMins}:${paddedSecs}`
    : `${paddedMins}:${paddedSecs}`;
};

/**
 * A component to display recording controls during a note taking session.
 *
 * @prop {boolean} isListening - Whether the component is currently listening to audio input.
 * @prop {number} recordingTime - The time in seconds of the current recording.
 * @prop {function} onRedo - A function to be called when the user wants to redo the recording.
 * @prop {function} onCancel - A function to be called when the user wants to cancel the recording.
 * @prop {function} onConfirm - A function to be called when the user wants to confirm the recording.
 * @prop {object} classes - An object containing CSS classes for styling the component.
/**
 */
const RecordingControls = ({
  isListening,
  recordingTime,
  onRedo,
  onCancel,
  onConfirm,
  classes = {},
}) => {
  if (!isListening) return null;

  return (
    <Box className={classes.waveSection}>
      <Box className={classes.wave}>
        <WaveformVisualizer isActive={isListening} />
      </Box>

      <Box className={classes.waveButtons}>
        <Button
          variant="light"
          color="gray"
          radius="xl"
          size="xs"
          onClick={onRedo}
        >
          <Flex align="center" gap={5}>
            <RecordingRedoSvg />
            <Text c="#525252">Redo</Text>
          </Flex>
        </Button>
        <Flex align="center" gap={5}>
          <Tooltip
            label="Cancel"
            withArrow
            position="top"
            arrowSize={8}
            color="white"
            styles={{
              tooltip: {
                color: "#000000",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <Box>
              <UnstyledButton variant="outline" color="gray" onClick={onCancel}>
                <RecordingCancelSvg />
              </UnstyledButton>
            </Box>
          </Tooltip>
          <Text size="sm" mt="sm" color="dimmed" pb={15}>
            {formatTime(recordingTime)}
          </Text>
          <Tooltip
            label="Confirm"
            withArrow
            position="top"
            arrowSize={8}
            color="white"
            styles={{
              tooltip: {
                color: "#000000",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <Box>
              <UnstyledButton onClick={onConfirm}>
                <RecordingTickMarkSvg />
              </UnstyledButton>
            </Box>
          </Tooltip>
        </Flex>
      </Box>
    </Box>
  );
};

export default RecordingControls;
